import { RESEND_VERIFY_EMAIL, VERIFY_EMAIL_RESET } from "../../actionTypes/actionsTypes";
import { AppAction, BaseAsyncReducerState } from "../../types";

export interface ResendEmailResponse extends BaseAsyncReducerState{
    sent: boolean;
}   

// Define an initial state value for the app
const initialState: ResendEmailResponse = {
    loading: false,
    error: false,
    sent: false,
}

function resendEmailReducer(state = initialState, action: AppAction): VerifyEmailResponse | Record<string, unknown> {

    const { payload } = action;

    switch (action.type) {
        case RESEND_VERIFY_EMAIL.PENDING:
            return {
                ...state,
                loading: true,
                error: false,
                verified: false,
            }
        case RESEND_VERIFY_EMAIL.SUCCESS:

            return {
                ...state,
                ...payload,
                loading: false,
                error: false,
            }

        case RESEND_VERIFY_EMAIL.ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };
        
        case VERIFY_EMAIL_RESET:
            return {
                ...state,
                ...initialState
            }

        default:
            // If the reducer doesn't care about this action type,
            // return the existing state unchanged
            return state
    }
}

export default resendEmailReducer;